import WorkForm from "./forms/workform";

export default function WorkWithUs() {
  return (
    <div
      className="relative block w-full lg:py-[73px] py-10 bg-[radial-gradient(113.98%_566.82%_at_-11.35%_1.51%,_#0F002E_0%,_#421A75_100%)]"
      style={{
        background: "url(https://glocify.com/images/redial-gradient.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}
    >
      <div className="contact-bg" />
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="lg:grid grid-cols-2">
          <div className="lg:mb-0 mb-8">
            <div className="lg:pl-6">
              <h2
                className="lg:text-[60px] text-[35px] text-white font-semibold lg:leading-[70px] tracking-tight mb-4"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <span className="bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent">
                  Get Started Now !!!
                </span>{" "}
              </h2>
              <h3 className="lg:text-[35px] text-[30px] text-white font-semibold lg:leading-[49px] tracking-tight"  data-aos="fade-up"
                data-aos-duration="1800">Fill Out the Form to Begin Your Journey.</h3>
              <p
                className="text-white text-base font-normal mt-[12px] mb-[32px] leading-6"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                Glocify: Bringing Your App Ideas to Life—Efficiently and
                Perfectly.
              </p>
            </div>
            <div className="w-full h-[1px] bg-white/20 mb-10" />
            <div
              className="flex gap-10 lg:pl-6 lg:flex-row flex-col"
              data-aos="fade-up"
              data-aos-duration="2500"
            >
              <div className="flex gap-4 items-start">
                <figure className="min-w-[45px]">
                  <img
                    src="https://glocify.com/images/email-address-purple.svg"
                    alt="email-address-icons"
                  />
                </figure>
                <div>
                  <h3 className="text-[20px] font-bold text-white leading-6 mb-1">
                    Email Address
                  </h3>
                  <p className="text-base font-normal leading-5">
                    <a href="mailto:Info@glocify.com" className="text-white">
                      info@glocify.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <figure className="min-w-[45px]">
                  <img
                    src="https://glocify.com/images/phone-icon-purple.svg"
                    alt="phone-icon"
                  />
                </figure>
                <div>
                  <h3 className="text-[20px] font-bold text-white leading-6 mb-1">
                    Call Now
                  </h3>
                  <p className="text-base font-normal">
                    <a href="tel:8288090864" className="underline text-white flex items-center gap-2">
                    <img src="https://glocify.com/images/usa-flag.svg" alt="" /> <span>+1 216-208-8072</span> 
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="lg:mb-0 mb-6 contact-form"
            data-aos="fade-left"
            data-aos-duration="2500"
          >
            <WorkForm />
          </div>
        </div>
      </div>
    </div>
  );
}
